import React from "react";
import styled from "styled-components";
import Window from "../Window";
import Tile from "../Tile";
import { CARD_BACKS } from "../Tile/tiles";

// The classic "Select Card Back" dialog (Game → Deck…). Choice persists
// in localStorage and applies immediately to the player's own game;
// neighbors keep their deterministic per-game backs.
export const CARD_BACK_KEY = "saat.cardBack";

function DeckPicker({ current, onChoose, onClose }) {
  return (
    <StyledWindow
      title="Select Card Back"
      controls={["close"]}
      onControlClick={(c) => c === "close" && onClose && onClose()}
    >
      <Body>
        <Grid>
          {CARD_BACKS.map((name) => (
            <BackButton
              key={name}
              type="button"
              data-selected={name === current ? "true" : undefined}
              onClick={() => {
                try {
                  localStorage.setItem(CARD_BACK_KEY, name);
                } catch {
                  // storage unavailable — session-only deck choice is fine
                }
                onChoose(name);
                if (onClose) onClose();
              }}
            >
              <Tile name={name} width={52} />
            </BackButton>
          ))}
        </Grid>
      </Body>
    </StyledWindow>
  );
}

const StyledWindow = styled(Window)`
  width: 420px;
`;

const Body = styled.div`
  padding: 10px 12px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  justify-items: center;
`;

const BackButton = styled.button`
  min-width: 0;
  min-height: 0;
  padding: 3px;
  background: transparent;
  border: none;
  box-shadow: none;

  &&[data-selected="true"] {
    outline: 2px solid #00007b;
    outline-offset: 1px;
  }
  &&:not(:disabled):hover {
    outline: 1px dotted #00007b;
    outline-offset: 1px;
  }
  &&:not(:disabled):active {
    box-shadow: none;
  }
  &&:focus {
    outline: 2px dotted #00007b;
  }
`;

export default DeckPicker;
